import {
  UNSTABLE_CONNECTION_AUTO_CLEAR_MS,
  UNSTABLE_CONNECTION_SNOOZE_MS,
} from "@zenith/data/constants";

let unstable = false;
let snoozedUntil = 0;
let autoClearTimer: ReturnType<typeof setTimeout> | null = null;

const listeners = new Set<() => void>();

const emit = () => {
  listeners.forEach((listener) => listener());
};

const clearAutoClearTimer = () => {
  if (autoClearTimer) {
    clearTimeout(autoClearTimer);
    autoClearTimer = null;
  }
};

export const subscribeNetworkHealth = (listener: () => void): (() => void) => {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
};

export const getUnstableConnectionSnapshot = (): boolean => unstable;

export const reportUnstableConnection = (): void => {
  if (Date.now() < snoozedUntil) return;

  clearAutoClearTimer();
  autoClearTimer = setTimeout(() => {
    autoClearTimer = null;
    if (unstable) {
      unstable = false;
      emit();
    }
  }, UNSTABLE_CONNECTION_AUTO_CLEAR_MS);

  if (!unstable) {
    unstable = true;
    emit();
  }
};

export const snoozeUnstableConnection = (): void => {
  snoozedUntil = Date.now() + UNSTABLE_CONNECTION_SNOOZE_MS;
  clearAutoClearTimer();
  if (unstable) {
    unstable = false;
    emit();
  }
};

export const resetNetworkHealth = (): void => {
  unstable = false;
  snoozedUntil = 0;
  clearAutoClearTimer();
  listeners.clear();
};
